export const PRESETS_2023 = [
    {
        key: "01",
        title: "Legacy",
        background: "#666666",
        color: "#FFFFFF",
    },
    {
        key: "02",
        title: "Legacy",
        background: "#666666",
        color: "#FFFFFF",
    },
    {
        key: "03",
        title: "Legacy",
        background: "#666666",
        color: "#FFFFFF",
    },
    {
        key: "04",
        title: "Legacy",
        background: "#666666",
        color: "#FFFFFF",
    },
    {
        key: "05",
        title: "Legacy",
        background: "#666666",
        color: "#FFFFFF",
    },
    {
        key: "06",
        title: "Legacy",
        background: "#666666",
        color: "#FFFFFF",
    },
    {
        key: "07",
        title: "Legacy",
        background: "#666666",
        color: "#FFFFFF",
    },
    {
        key: "08",
        title: "Legacy",
        background: "#666666",
        color: "#FFFFFF",
    },
    {
        key: "09",
        title: "Legacy",
        background: "#666666",
        color: "#FFFFFF",
    },
    {
        key: "10",
        title: "Legacy",
        background: "#666666",
        color: "#FFFFFF",
    },
    {
        key: "A1",
        title: "Analog",
        background: "#AC3220",
        color: "#FFFFFF",
    },
    {
        key: "A2",
        title: "Analog",
        background: "#AC3220",
        color: "#FFFFFF",
    },
    {
        key: "A3",
        title: "Analog",
        background: "#AC3220",
        color: "#FFFFFF",
    },
    {
        key: "A4",
        title: "Analog",
        background: "#AC3220",
        color: "#FFFFFF",
    },
    {
        key: "A5",
        title: "Analog",
        background: "#AC3220",
        color: "#FFFFFF",
    },
    {
        key: "A6",
        title: "Analog",
        background: "#AC3220",
        color: "#FFFFFF",
    },
    {
        key: "A7",
        title: "Analog",
        background: "#AC3220",
        color: "#FFFFFF",
    },
    {
        key: "A8",
        title: "Analog",
        background: "#AC3220",
        color: "#FFFFFF",
    },
    {
        key: "A9",
        title: "Analog",
        background: "#AC3220",
        color: "#FFFFFF",
    },
    {
        key: "A10",
        title: "Analog",
        background: "#AC3220",
        color: "#FFFFFF",
    },
    {
        key: "AGA1",
        title: "Agave",
        background: "#249065",
        color: "#FFFFFF",
    },
    {
        key: "AGA2",
        title: "Agave Pop",
        background: "#249065",
        color: "#FFFFFF",
    },
    {
        key: "AGA3",
        title: "Agave Mute",
        background: "#249065",
        color: "#FFFFFF",
    },
    {
        key: "AL1",
        title: "LED Soften",
        background: "#612010",
        color: "#FFFFFF",
    },
    {
        key: "AL2",
        title: "LED Boost",
        background: "#612010",
        color: "#FFFFFF",
    },
    {
        key: "AL3",
        title: "Flourescent Soften",
        background: "#612010",
        color: "#FFFFFF",
    },
    {
        key: "AL4",
        title: "Flourescent Boost",
        background: "#612010",
        color: "#FFFFFF",
    },
    {
        key: "AL5",
        title: "Mixed Soften",
        background: "#612010",
        color: "#FFFFFF",
    },
    {
        key: "AL6",
        title: "Mixed Boost",
        background: "#612010",
        color: "#FFFFFF",
    },
    {
        key: "B1",
        title: "B&W Classic",
        background: "#DE5539",
        color: "#FFFFFF",
    },
    {
        key: "B2",
        title: "B&W Classic",
        background: "#DE5539",
        color: "#FFFFFF",
    },
    {
        key: "B3",
        title: "B&W Classic",
        background: "#DE5539",
        color: "#FFFFFF",
    },
    {
        key: "B4",
        title: "B&W Classic",
        background: "#DE5539",
        color: "#FFFFFF",
    },
    {
        key: "B5",
        title: "B&W Classic",
        background: "#DE5539",
        color: "#FFFFFF",
    },
    {
        key: "B6",
        title: "B&W Classic",
        background: "#DE5539",
        color: "#FFFFFF",
    },
    {
        key: "BBMA",
        title: "Billboard Music Awards",
        background: "#00FFFF",
        color: "#FFFFFF",
    },
    {
        key: "C1",
        title: "Chromatic",
        background: "#E46A34",
        color: "#FFFFFF",
    },
    {
        key: "C2",
        title: "Chromatic",
        background: "#E46A34",
        color: "#FFFFFF",
    },
    {
        key: "C3",
        title: "Chromatic",
        background: "#E46A34",
        color: "#FFFFFF",
    },
    {
        key: "C4",
        title: "Chromatic",
        background: "#E46A34",
        color: "#FFFFFF",
    },
    {
        key: "C5",
        title: "Chromatic",
        background: "#E46A34",
        color: "#FFFFFF",
    },
    {
        key: "C6",
        title: "Chromatic",
        background: "#E46A34",
        color: "#FFFFFF",
    },
    {
        key: "C7",
        title: "Chromatic",
        background: "#E46A34",
        color: "#FFFFFF",
    },
    {
        key: "C8",
        title: "Chromatic",
        background: "#E46A34",
        color: "#FFFFFF",
    },
    {
        key: "C9",
        title: "Chromatic",
        background: "#E46A34",
        color: "#FFFFFF",
    },
    {
        key: "D1",
        title: "Distortia",
        background: "#46E3E2",
        color: "#FFFFFF",
    },
    {
        key: "D2",
        title: "Distortia",
        background: "#46E3E2",
        color: "#FFFFFF",
    },
    {
        key: "DOG1",
        title: "Isle of Dogs",
        background: "#6F604E",
        color: "#FFFFFF",
    },
    {
        key: "DOG2",
        title: "Isle of Dogs",
        background: "#6F604E",
        color: "#FFFFFF",
    },
    {
        key: "DOG3",
        title: "Isle of Dogs",
        background: "#6F604E",
        color: "#FFFFFF",
    },
    {
        key: "E1",
        title: "Essence",
        background: "#F0A326",
        color: "#FFFFFF",
    },
    {
        key: "E2",
        title: "Essence",
        background: "#F0A326",
        color: "#FFFFFF",
    },
    {
        key: "E3",
        title: "Essence",
        background: "#F0A326",
        color: "#FFFFFF",
    },
    {
        key: "E4",
        title: "Essence",
        background: "#F0A326",
        color: "#FFFFFF",
    },
    {
        key: "E5",
        title: "Essence",
        background: "#F0A326",
        color: "#FFFFFF",
    },
    {
        key: "E6",
        title: "Essence",
        background: "#F0A326",
        color: "#FFFFFF",
    },
    {
        key: "E7",
        title: "Essence",
        background: "#F0A326",
        color: "#FFFFFF",
    },
    {
        key: "E8",
        title: "Essence",
        background: "#F0A326",
        color: "#FFFFFF",
    },
    {
        key: "F1",
        title: "Mellow",
        background: "#FBE831",
        color: "#FFFFFF",
    },
    {
        key: "F2",
        title: "Mellow",
        background: "#FBE831",
        color: "#FFFFFF",
    },
    {
        key: "F3",
        title: "Mellow",
        background: "#FBE831",
        color: "#FFFFFF",
    },
    {
        key: "G1",
        title: "Portraits",
        background: "#C8CC1C",
        color: "#FFFFFF",
    },
    {
        key: "G2",
        title: "Portraits",
        background: "#C8CC1C",
        color: "#FFFFFF",
    },
    {
        key: "G3",
        title: "Portraits",
        background: "#C8CC1C",
        color: "#FFFFFF",
    },
    {
        key: "G4",
        title: "Cool Portrait",
        background: "#C8CC1C",
        color: "#FFFFFF",
    },
    {
        key: "G5",
        title: "Cool Portrait",
        background: "#C8CC1C",
        color: "#FFFFFF",
    },
    {
        key: "G6",
        title: "Neutral Portrait",
        background: "#C8CC1C",
        color: "#FFFFFF",
    },
    {
        key: "G7",
        title: "Neutral Portrait",
        background: "#C8CC1C",
        color: "#FFFFFF",
    },
    {
        key: "G8",
        title: "Warm Portrait",
        background: "#C8CC1C",
        color: "#FFFFFF",
    },
    {
        key: "G9",
        title: "Warm Portrait",
        background: "#C8CC1C",
        color: "#FFFFFF",
    },
    {
        key: "H1",
        title: "Polychrome",
        background: "#7DAE30",
        color: "#FFFFFF",
    },
    {
        key: "H2",
        title: "Polychrome",
        background: "#7DAE30",
        color: "#FFFFFF",
    },
    {
        key: "H3",
        title: "Polychrome",
        background: "#7DAE30",
        color: "#FFFFFF",
    },
    {
        key: "H4",
        title: "Polychrome",
        background: "#7DAE30",
        color: "#FFFFFF",
    },
    {
        key: "H5",
        title: "Polychrome",
        background: "#7DAE30",
        color: "#FFFFFF",
    },
    {
        key: "H6",
        title: "Polychrome",
        background: "#7DAE30",
        color: "#FFFFFF",
    },
    {
        key: "HB1",
        title: "Hypebeast",
        background: "#A5ACB2",
        color: "#FFFFFF",
    },
    {
        key: "HB2",
        title: "Hypebeast",
        background: "#A5ACB2",
        color: "#FFFFFF",
    },
    {
        key: "IND1",
        title: "Indigo Hard",
        background: "#040D69",
        color: "#FFFFFF",
    },
    {
        key: "IND2",
        title: "Indigo Soft",
        background: "#040D69",
        color: "#FFFFFF",
    },
    {
        key: "IR1",
        title: "Infrared Landscapes",
        background: "#F50F35",
        color: "#FFFFFF",
    },
    {
        key: "IR2",
        title: "Infrared Portraits",
        background: "#F50F35",
        color: "#FFFFFF",
    },
    {
        key: "IR3",
        title: "Infrared B&W",
        background: "#F50F35",
        color: "#FFFFFF",
    },
    {
        key: "IR4",
        title: "Infrared Landscapes",
        background: "#F50F35",
        color: "#FFFFFF",
    },
    {
        key: "IR5",
        title: "Infrared Portraits",
        background: "#F50F35",
        color: "#FFFFFF",
    },
    {
        key: "IR6",
        title: "Infrared Landscapes",
        background: "#F50F35",
        color: "#FFFFFF",
    },
    {
        key: "IR7",
        title: "Infrared Portraits",
        background: "#F50F35",
        color: "#FFFFFF",
    },
    {
        key: "J1",
        title: "Minimalist",
        background: "#54902D",
        color: "#FFFFFF",
    },
    {
        key: "J2",
        title: "Minimalist",
        background: "#54902D",
        color: "#FFFFFF",
    },
    {
        key: "J3",
        title: "Minimalist",
        background: "#54902D",
        color: "#FFFFFF",
    },
    {
        key: "J4",
        title: "Minimalist",
        background: "#54902D",
        color: "#FFFFFF",
    },
    {
        key: "J5",
        title: "Minimalist",
        background: "#54902D",
        color: "#FFFFFF",
    },
    {
        key: "J6",
        title: "Minimalist",
        background: "#54902D",
        color: "#FFFFFF",
    },
    {
        key: "K1",
        title: "Analog Classic",
        background: "#367F3B",
        color: "#FFFFFF",
    },
    {
        key: "K2",
        title: "Analog Classic",
        background: "#367F3B",
        color: "#FFFFFF",
    },
    {
        key: "K3",
        title: "Analog Classic",
        background: "#367F3B",
        color: "#FFFFFF",
    },
    {
        key: "L1",
        title: "Mountain",
        background: "#12D60B",
        color: "#FFFFFF",
    },
    {
        key: "L2",
        title: "Mountain",
        background: "#12D60B",
        color: "#FFFFFF",
    },
    {
        key: "L3",
        title: "Mountain",
        background: "#12D60B",
        color: "#FFFFFF",
    },
    {
        key: "L4",
        title: "Valley",
        background: "#12D60B",
        color: "#FFFFFF",
    },
    {
        key: "L5",
        title: "Forest",
        background: "#12D60B",
        color: "#FFFFFF",
    },
    {
        key: "L6",
        title: "Valley",
        background: "#12D60B",
        color: "#FFFFFF",
    },
    {
        key: "L7",
        title: "Beach",
        background: "#12D60B",
        color: "#FFFFFF",
    },
    {
        key: "L8",
        title: "Beach",
        background: "#12D60B",
        color: "#FFFFFF",
    },
    {
        key: "L9",
        title: "Coast",
        background: "#12D60B",
        color: "#FFFFFF",
    },
    {
        key: "L10",
        title: "Desert",
        background: "#12D60B",
        color: "#FFFFFF",
    },
    {
        key: "L11",
        title: "Desert",
        background: "#12D60B",
        color: "#FFFFFF",
    },
    {
        key: "L12",
        title: "Desert",
        background: "#12D60B",
        color: "#FFFFFF",
    },
    {
        key: "M1",
        title: "Mood",
        background: "#1E5652",
        color: "#FFFFFF",
    },
    {
        key: "M2",
        title: "Mood",
        background: "#1E5652",
        color: "#FFFFFF",
    },
    {
        key: "M3",
        title: "Mood",
        background: "#1E5652",
        color: "#FFFFFF",
    },
    {
        key: "M4",
        title: "Mood",
        background: "#1E5652",
        color: "#FFFFFF",
    },
    {
        key: "M5",
        title: "Mood",
        background: "#1E5652",
        color: "#FFFFFF",
    },
    {
        key: "M6",
        title: "Mood",
        background: "#1E5652",
        color: "#FFFFFF",
    },
    {
        key: "N1",
        title: "New Modern",
        background: "#0E4764",
        color: "#FFFFFF",
    },
    {
        key: "N2",
        title: "New Modern",
        background: "#0E4764",
        color: "#FFFFFF",
    },
    {
        key: "N3",
        title: "New Modern",
        background: "#0E4764",
        color: "#FFFFFF",
    },
    {
        key: "NC",
        title: "Neocha",
        background: "#000000",
        color: "#FFFFFF",
    },
    {
        key: "OAK1",
        title: "Oakley PRIZM Tungsten",
        background: "#0000FF",
        color: "#FFFFFF",
    },
    {
        key: "OAK2",
        title: "Oakley PRIZM Road",
        background: "#0000FF",
        color: "#FFFFFF",
    },
    {
        key: "OAK3",
        title: "Oakley PRIZM Snow",
        background: "#0000FF",
        color: "#FFFFFF",
    },
    {
        key: "P1",
        title: "Instant",
        background: "#1768A4",
        color: "#FFFFFF",
    },
    {
        key: "P2",
        title: "Instant",
        background: "#1768A4",
        color: "#FFFFFF",
    },
    {
        key: "P3",
        title: "Instant",
        background: "#1768A4",
        color: "#FFFFFF",
    },
    {
        key: "P4",
        title: "Instant",
        background: "#1768A4",
        color: "#FFFFFF",
    },
    {
        key: "P5",
        title: "Instant",
        background: "#1768A4",
        color: "#FFFFFF",
    },
    {
        key: "P6",
        title: "Instant",
        background: "#1768A4",
        color: "#FFFFFF",
    },
    {
        key: "P7",
        title: "Instant",
        background: "#1768A4",
        color: "#FFFFFF",
    },
    {
        key: "P8",
        title: "Instant",
        background: "#1768A4",
        color: "#FFFFFF",
    },
    {
        key: "P9",
        title: "Instant",
        background: "#1768A4",
        color: "#FFFFFF",
    },
    {
        key: "Q1",
        title: "Alchemy",
        background: "#1E7BC1",
        color: "#FFFFFF",
    },
    {
        key: "Q2",
        title: "Alchemy",
        background: "#1E7BC1",
        color: "#FFFFFF",
    },
    {
        key: "Q3",
        title: "Alchemy",
        background: "#1E7BC1",
        color: "#FFFFFF",
    },
    {
        key: "Q4",
        title: "Alchemy",
        background: "#1E7BC1",
        color: "#FFFFFF",
    },
    {
        key: "Q5",
        title: "Alchemy",
        background: "#1E7BC1",
        color: "#FFFFFF",
    },
    {
        key: "Q6",
        title: "Alchemy",
        background: "#1E7BC1",
        color: "#FFFFFF",
    },
    {
        key: "Q7",
        title: "Alchemy",
        background: "#1E7BC1",
        color: "#FFFFFF",
    },
    {
        key: "Q8",
        title: "Alchemy",
        background: "#1E7BC1",
        color: "#FFFFFF",
    },
    {
        key: "Q9",
        title: "Alchemy",
        background: "#1E7BC1",
        color: "#FFFFFF",
    },
    {
        key: "Q10",
        title: "Alchemy",
        background: "#1E7BC1",
        color: "#FFFFFF",
    },
    {
        key: "S1",
        title: "Clean",
        background: "#74AEDE",
        color: "#FFFFFF",
    },
    {
        key: "S2",
        title: "Clean",
        background: "#74AEDE",
        color: "#FFFFFF",
    },
    {
        key: "S3",
        title: "Clean",
        background: "#74AEDE",
        color: "#FFFFFF",
    },
    {
        key: "S4",
        title: "Clean",
        background: "#74AEDE",
        color: "#FFFFFF",
    },
    {
        key: "S5",
        title: "Clean",
        background: "#74AEDE",
        color: "#FFFFFF",
    },
    {
        key: "S6",
        title: "Clean",
        background: "#74AEDE",
        color: "#FFFFFF",
    },
    {
        key: "SS1",
        title: "Vibrant Accents",
        background: "#0EFF7B",
        color: "#FFFFFF",
    },
    {
        key: "SS2",
        title: "Muted Moments",
        background: "#0EFF7B",
        color: "#FFFFFF",
    },
    {
        key: "SS3",
        title: "In the Shadows",
        background: "#0EFF7B",
        color: "#FFFFFF",
    },
    {
        key: "SUM1",
        title: "Sumac Hard",
        background: "#700907",
        color: "#FFFFFF",
    },
    {
        key: "SUM2",
        title: "Sumac Soft",
        background: "#700907",
        color: "#FFFFFF",
    },
    {
        key: "T1",
        title: "Moody",
        background: "#B2CBE9",
        color: "#FFFFFF",
    },
    {
        key: "T2",
        title: "Moody",
        background: "#B2CBE9",
        color: "#FFFFFF",
    },
    {
        key: "T3",
        title: "Moody",
        background: "#B2CBE9",
        color: "#FFFFFF",
    },
    {
        key: "TECH",
        title: "Nike Sportswear Tech Pack",
        background: "#D42022",
        color: "#FFFFFF",
    },
    {
        key: "TK",
        title: "Ta-ku",
        background: "#000000",
        color: "#FFFFFF",
    },
    {
        key: "U1",
        title: "Bright Sun",
        background: "#6A6A6A",
        color: "#FFFFFF",
    },
    {
        key: "U2",
        title: "High Sun",
        background: "#6A6A6A",
        color: "#FFFFFF",
    },
    {
        key: "U3",
        title: "Overcast",
        background: "#6A6A6A",
        color: "#FFFFFF",
    },
    {
        key: "U4",
        title: "Low Sun",
        background: "#6A6A6A",
        color: "#FFFFFF",
    },
    {
        key: "U5",
        title: "Sunset",
        background: "#6A6A6A",
        color: "#FFFFFF",
    },
    {
        key: "U6",
        title: "Darkness",
        background: "#6A6A6A",
        color: "#FFFFFF",
    },
    {
        key: "V1",
        title: "Valence",
        background: "#9100FF",
        color: "#FFFFFF",
    },
    {
        key: "V2",
        title: "Valence",
        background: "#9100FF",
        color: "#FFFFFF",
    },
    {
        key: "V3",
        title: "Valence",
        background: "#9100FF",
        color: "#FFFFFF",
    },
    {
        key: "V4",
        title: "Valence",
        background: "#9100FF",
        color: "#FFFFFF",
    },
    {
        key: "V5",
        title: "Valence",
        background: "#9100FF",
        color: "#FFFFFF",
    },
    {
        key: "V6",
        title: "Valence",
        background: "#9100FF",
        color: "#FFFFFF",
    },
    {
        key: "V7",
        title: "Valence",
        background: "#9100FF",
        color: "#FFFFFF",
    },
    {
        key: "V8",
        title: "Valence",
        background: "#9100FF",
        color: "#FFFFFF",
    },
    {
        key: "WE",
        title: "We the Creators",
        background: "#000000",
        color: "#FFFFFF",
    },
    {
        key: "X1",
        title: "B&W Fade",
        background: "#B387AA",
        color: "#FFFFFF",
    },
    {
        key: "X2",
        title: "B&W Fade",
        background: "#B387AA",
        color: "#FFFFFF",
    },
    {
        key: "X3",
        title: "B&W Fade",
        background: "#B387AA",
        color: "#FFFFFF",
    },
    {
        key: "X4",
        title: "B&W Fade",
        background: "#B387AA",
        color: "#FFFFFF",
    },
    {
        key: "X5",
        title: "B&W Fade",
        background: "#B387AA",
        color: "#FFFFFF",
    },
    {
        key: "X6",
        title: "B&W Fade",
        background: "#B387AA",
        color: "#FFFFFF",
    },
    {
        key: "AU1",
        title: "Agfa Ultra 100",
        background: "#FFFFFF",
        color: "#674ea7",
    },
    {
        key: "AU5",
        title: "Agfa Ultra 50",
        background: "#FFFFFF",
        color: "#674ea7",
    },
    {
        key: "AV4",
        title: "Agfa Vista 400",
        background: "#FFFFFF",
        color: "#cc0000",
    },
    {
        key: "AV8",
        title: "Agfa Vista 800",
        background: "#FFFFFF",
        color: "#cc0000",
    },
    {
        key: "FA1",
        title: "Fuji Astia 100F",
        background: "#FFFFFF",
        color: "#0000ff",
    },
    {
        key: "FF5",
        title: "Fuji Fortia SP",
        background: "#FFFFFF",
        color: "#351c75",
    },
    {
        key: "FN16",
        title: "Fuji Neopan 1600",
        background: "#FFFFFF",
        color: "#38761d",
    },
    {
        key: "FP1",
        title: "Fuji Pro 160S",
        background: "#FFFFFF",
        color: "#38761d",
    },
    {
        key: "FP2",
        title: "Fuji Pro 160C",
        background: "#FFFFFF",
        color: "#38761d",
    },
    {
        key: "FP4",
        title: "Fuji Pro 400H",
        background: "#FFFFFF",
        color: "#38761d",
    },
    {
        key: "FP8",
        title: "Fuji Pro 800Z",
        background: "#FFFFFF",
        color: "#38761d",
    },
    {
        key: "FR4",
        title: "Fuji Provia 400X",
        background: "#FFFFFF",
        color: "#674ea7",
    },
    {
        key: "FR4X",
        title: "Fuji Provia 400X Cross-Processed",
        background: "#FFFFFF",
        color: "#674ea7",
    },
    {
        key: "FS1",
        title: "Fuji Superia 100",
        background: "#FFFFFF",
        color: "#38761d",
    },
    {
        key: "FS4",
        title: "Fuji Superia 400",
        background: "#FFFFFF",
        color: "#38761d",
    },
    {
        key: "FS16",
        title: "Fuji Superia 1600",
        background: "#FFFFFF",
        color: "#38761d",
    },
    {
        key: "FT6",
        title: "Fuji T64",
        background: "#FFFFFF",
        color: "#ff0000",
    },
    {
        key: "FV5",
        title: "Fuji Velvia 50",
        background: "#FFFFFF",
        color: "#1155cc",
    },
    {
        key: "IH5",
        title: "Ilford HP5",
        background: "#FFFFFF",
        color: "#000000",
    },
    {
        key: "KA1",
        title: "Kodak Ektachrome E100G",
        background: "#FFFFFF",
        color: "#1155cc",
    },
    {
        key: "KA3",
        title: "Kodak Ektachrome E100VS",
        background: "#FFFFFF",
        color: "#1155cc",
    },
    {
        key: "KA3X",
        title: "Kodak E100VS Cross-Processed",
        background: "#FFFFFF",
        color: "#1155cc",
    },
    {
        key: "KC25",
        title: "Kodak Kodachrome 25",
        background: "#FFFFFF",
        color: "#f1c232",
    },
    {
        key: "KCP2",
        title: "Kodak ColorPlus 200",
        background: "#FFFFFF",
        color: "#e69138",
    },
    {
        key: "KE1",
        title: "Kodak Ektar 100",
        background: "#FFFFFF",
        color: "#cc0000",
    },
    {
        key: "KG1",
        title: "Kodak Gold 100",
        background: "#FFFFFF",
        color: "#3d85c6",
    },
    {
        key: "KG2",
        title: "Kodak Gold 200",
        background: "#FFFFFF",
        color: "#3d85c6",
    },
    {
        key: "KP1",
        title: "Kodak Portra 160",
        background: "#FFFFFF",
        color: "#741b47",
    },
    {
        key: "KP2",
        title: "Kodak Portra 160NC",
        background: "#FFFFFF",
        color: "#741b47",
    },
    {
        key: "KP3",
        title: "Kodak Portra 160VC",
        background: "#FFFFFF",
        color: "#741b47",
    },
    {
        key: "KP4",
        title: "Kodak Portra 400",
        background: "#FFFFFF",
        color: "#741b47",
    },
    {
        key: "KP5",
        title: "Kodak Portra 400NC",
        background: "#FFFFFF",
        color: "#741b47",
    },
    {
        key: "KP6",
        title: "Kodak Portra 400VC",
        background: "#FFFFFF",
        color: "#741b47",
    },
    {
        key: "KP7",
        title: "Kodak Portra 400UC",
        background: "#FFFFFF",
        color: "#741b47",
    },
    {
        key: "KP8",
        title: "Kodak Portra 800",
        background: "#FFFFFF",
        color: "#741b47",
    },
    {
        key: "KP9",
        title: "Kodak Portra 100T",
        background: "#FFFFFF",
        color: "#741b47",
    },
    {
        key: "KT32",
        title: "Kodak T-MAX 3200",
        background: "#FFFFFF",
        color: "#38761d",
    },
    {
        key: "KU1",
        title: "Kodak Ultra Color 100",
        background: "#FFFFFF",
        color: "#ff00ff",
    },
    {
        key: "KU4",
        title: "Kodak GC/Ultramax 400",
        background: "#FFFFFF",
        color: "#1155cc",
    },
    {
        key: "KU8",
        title: "Kodak Ultramax 800",
        background: "#FFFFFF",
        color: "#1155cc",
    },
    {
        key: "KX4",
        title: "Kodak TRI-X 400",
        background: "#FFFFFF",
        color: "#38761d",
    },
    {
        key: "SE1",
        title: "Street Etiquette",
        background: "#0E1C33",
        color: "#FFFFFF",
    },
    {
        key: "SE2",
        title: "Street Etiquette",
        background: "#0E1C33",
        color: "#FFFFFF",
    },
    {
        key: "SE3",
        title: "Street Etiquette",
        background: "#0E1C33",
        color: "#FFFFFF",
    },
    {
        key: "01PRO",
        title: "Legacy",
        background: "#666666",
        color: "#FFFFFF",
        borderColor: "#EDBA58",
    },
    {
        key: "A4PRO",
        title: "Analog",
        background: "#AC3220",
        color: "#FFFFFF",
        borderColor: "#EDBA58",
    },
    {
        key: "A6PRO",
        title: "Analog",
        background: "#AC3220",
        color: "#FFFFFF",
        borderColor: "#EDBA58",
    },
    {
        key: "A8PRO",
        title: "Analog",
        background: "#AC3220",
        color: "#FFFFFF",
        borderColor: "#EDBA58",
    },
    {
        key: "AL1PRO",
        title: "LED Soften",
        background: "#612010",
        color: "#FFFFFF",
        borderColor: "#EDBA58",
    },
    {
        key: "AL3PRO",
        title: "Flourescent Soften",
        background: "#612010",
        color: "#FFFFFF",
        borderColor: "#EDBA58",
    },
    {
        key: "B1PRO",
        title: "B&W Classic",
        background: "#DE5539",
        color: "#FFFFFF",
        borderColor: "#EDBA58",
    },
    {
        key: "B5PRO",
        title: "B&W Classic",
        background: "#DE5539",
        color: "#FFFFFF",
        borderColor: "#EDBA58",
    },
    {
        key: "C1PRO",
        title: "Chromatic",
        background: "#E46A34",
        color: "#FFFFFF",
        borderColor: "#EDBA58",
    },
    {
        key: "C8PRO",
        title: "Chromatic",
        background: "#E46A34",
        color: "#FFFFFF",
        borderColor: "#EDBA58",
    },
    {
        key: "G6PRO",
        title: "Neutral Portrait",
        background: "#C8CC1C",
        color: "#FFFFFF",
        borderColor: "#EDBA58",
    },
    {
        key: "M5PRO",
        title: "Mood",
        background: "#1E5652",
        color: "#FFFFFF",
        borderColor: "#EDBA58",
    },
    {
        key: "SS1PRO",
        title: "Vibrant Accents",
        background: "#0EFF7B",
        color: "#FFFFFF",
        borderColor: "#EDBA58",
    },
    {
        key: "V3PRO",
        title: "Valence",
        background: "#9100FF",
        color: "#FFFFFF",
        borderColor: "#EDBA58",
    },
    { key: "CG1", title: "Duotone Low", background: "#EF1500", color: "#FFFFFF" },
    {
        key: "CG2",
        title: "Duotone High",
        background: "#EF1500",
        color: "#FFFFFF",
    },
    { key: "CG3", title: "Blue Low", background: "#EF1500", color: "#FFFFFF" },
    { key: "CG4", title: "Blue High", background: "#EF1500", color: "#FFFFFF" },
    { key: "CG5", title: "Gold Low", background: "#EF1500", color: "#FFFFFF" },
    { key: "CG6", title: "Gold High", background: "#EF1500", color: "#FFFFFF" },
    { key: "CG7", title: "Green Low", background: "#EF1500", color: "#FFFFFF" },
    { key: "CG8", title: "Green High", background: "#EF1500", color: "#FFFFFF" },
];
export const getPresetConfigByKey = (key) => {
    const presetConfig = PRESETS_2023.find((item) => item.key.toUpperCase() === key.toUpperCase());
    if (presetConfig) {
        return presetConfig;
    }
    console.warn("Preset not found", key);
    return {
        key,
        title: key.toUpperCase(),
        background: "#333",
        color: "#FFFFFF",
    };
};
